<template>
  <div class="hello">
    <!-- ////////////// Header Start ////////////// -->
    <app-header></app-header>
    <!-- ////////////// Header End ////////////// -->
    <!--     
    <div class="arrow-dark"></div>
    <div class="h2-arrow green-inverse">CONFIRMATION<br/>VOTRE DIFFUSION EST ENREGISTRÉE</div> -->
    <div class="info-box">
      <svg class="info-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="8949 -947 14.89 50"><path class="a" d="M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z" transform="translate(8926.444 -1944.365)"/></svg>
      <div class="info-text">
        Confirmation, votre communication est enregistrée
      </div>
    </div>
    <!-- Button trigger modal -->
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
export default {
  name: 'confirmation',
  data () {
    return {
      user: AppModules.getUser()
    }
  },
  components: {
    'app-header': Header,
    'app-footer': Footer
  },
  mounted: function () {
    var self = this
    this.user.getProperties(function (err, userProps) {
      if (err) {
        self.$router.replace('/')
      }
      setTimeout(function () {
        self.$router.replace('/app/home')
      }, 2000)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.hello {
  /*background-image: url(../assets/images/votre-espace-2-orange.png);*/
  background-position: 0 50px;
  background-repeat: no-repeat;
  width: 733px;
  /*min-height: 505px;*/
  /*min-height: calc(100vh - 500px);*/
  margin: auto;
}

#authentMe {
  width: 275px;
  padding-top: 180px;
  margin: auto;
}

#authentMe a {
  color: var(--grey-eighth-color);
  text-decoration: underline;
}

#authentMe a:hover {
  color: var(--primary-color);
}

.info-box {
  transition: opacity 0.8s ease;
  background: url(/static/images/info_msg.svg) top center no-repeat;
  width: 667px;
  height: 103px;
  text-align: left;
  position: absolute;
  top: 25vh;
  opacity: 1;
}

.info-text {
  text-align: center;
  color: var(--info-primary-color);
  font-family: 'Open Sans', Arial;
  font-weight: 400;
  font-size: 14px;
  height: 30px;
  display: inline-block;
  position: relative;
  width: 498px;
  height: 45px;
  top: calc(50% - (75px / 2));
  left: calc(50% - (498px / 2));
}

</style>



// WEBPACK FOOTER //
// Confirmation.vue?432064b6